import { ConfigObj } from './'

// Default options for this module
const defaultOpts = {
  method: 'GET',
  requestHeaders: [
    { key: 'Content-Type', value: 'application/json' }
  ],
  queryParams: {},
  onLoad: undefined,
  onError: undefined
}

/**
 * Constructs a uri encoded string of query params from a kvp object
 * @param {any} queryObj
 */
const buildQueryString = queryObj => {
  if (!queryObj instanceof Object) return ''

  const params = []

  for (const query in queryObj) params.push(encodeURI(`${query}=${queryObj[query]}`))

  return params.length
    ? `?${params.join('&')}`
    : ''
}

/**
 * Sends an HTTP request to a given URI with optional props
 * @param {any} uri - the endpoint to send request to
 * @param {any} opts - Sets the defined parameters of the request (headers etc)
 * TODO: Break out into sub functions
 */
const request = function (uri, opts) {

  const _opts = Object.assign(defaultOpts, opts)

  const http = new XMLHttpRequest()

  uri = encodeURI(uri)

  if (_opts.queryParams) uri = uri + buildQueryString(_opts.queryParams)

  http.open(_opts.method, uri)

  _opts.requestHeaders.forEach(header => http.setRequestHeader(header.key, header.value))

  if (_opts.method === 'POST') {
    // Set all passed request headers

    http.send(buildQueryString(_opts.queryParams))

  } else {

    http.send()

  }

  // Callback function to run when ajax request loads
  http.onload = function () {
    if (/500/.test(this.status)) return http.onerror()

    if (/20(?:0|1|2)/.test(this.status) && this.readyState == 4) {
      let response = this.responseText.replace(/\n\s*/g, '')

      //If the returned data is JSON parse it
      // TODO: add full mime type support
      response = /^{(?:.+:.+,*)*}$/g.test(response) ? JSON.parse(response) : response

      if (_opts.onLoad) _opts.onLoad(response)

    } else {

      console.error(`${this.status}: ${this.statusText}`)

    }
  }

  // Callback function to run when ajax request fails
  http.onerror = function () {

    typeof _opts.onError == 'function'
      ? _opts.onError(this.statusText)
      : console.error(this.statusText)
  }

}

const Ajax = {
  request
}

export default Ajax



// WEBPACK FOOTER //
// ./js/utils/Ajax.js